import React, { Component } from "react";
import scrollIntoView from "scroll-into-view-if-needed";
import classnames from "classnames";

import { useDesktopMenuItems } from "../menu.config";
import { sizes } from "../../../hocs/Responsive";
import { primaryNavigationId } from "../mainNavigation";
import { useActiveTopLinkSubMenu, TopLinkSubMenu } from "../mainNavigation";

import "./HorizontalMenu.scss";

export const horizontalMenuPortalClassName = "hm__page-name__portal";

class HorizontalMenu extends Component {
  componentDidMount() {
    this.scrollToActive();
  }

  componentDidUpdate() {
    if (window.innerWidth <= sizes.mobileMax) {
      this.scrollToActive();
    }
  }

  get activeOption() {
    return this.hmRef.querySelector(".active");
  }

  scrollToActive = () =>
    this.activeOption &&
    scrollIntoView(this.activeOption, { inline: "center" });

  render() {
    const { items } = this.props;

    const portalClasses = classnames(horizontalMenuPortalClassName, {
      [`${horizontalMenuPortalClassName}--with-sub-menu`]: items,
    });

    return (
      <div
        id={primaryNavigationId}
        className="hm__wrapper"
        ref={(ref) => (this.hmRef = ref)}
      >
        <div className={portalClasses} />

        {items && <TopLinkSubMenu items={items} />}
      </div>
    );
  }
}

export const HorizontalMenuWrapper = () => {
  const menuItems = useDesktopMenuItems();
  const activeTopLinkSubMenu = useActiveTopLinkSubMenu(menuItems);

  return <HorizontalMenu items={activeTopLinkSubMenu} />;
};

export default HorizontalMenuWrapper;
